import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { Box } from '../../../../../Components/CustomUi/box'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import { removerAcentos } from '../../../../../utils'
import { faEdit, faMapLocationDot, faPlus } from '@fortawesome/free-solid-svg-icons'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import { Empty, Tag } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { Select } from '../../../../../Components/CustomUi/Select'
import { SetStateAction, useState } from 'react'

interface Props {
  loading: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  listar_atribuicao: any[]
  propriedades: any[]
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  permissao: ItensPerUserLogged
  editarCadastro: Function
  deletar: Function
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  propriedade_selecionada: string
  setPropriedade_selecionada: React.Dispatch<React.SetStateAction<string>>
  propriedade_selecionada_id: number
  setIdPropriedade_selecionada: React.Dispatch<React.SetStateAction<number>>
}

export const TabelaAtribuicaoCargos: React.FC<Props> = ({
  loading,
  page,
  setPage,
  setPagination,
  total,
  listar_atribuicao,
  propriedades,
  setOpen,
  permissao,
  editarCadastro,
  deletar,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  buscarTabela,
  setBuscarTabela,
  propriedade_selecionada,
  setPropriedade_selecionada,
  propriedade_selecionada_id,
  setIdPropriedade_selecionada,
}) => {
  const [openSelect, setOpenSelect] = useState<boolean>(false)

  function buscarAtribuicao(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.usuario))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  function listagemCargos(item) {
    const dados = item?.filter((word) => word !== '')
    const filtro =
      propriedade_selecionada_id > 0
        ? dados
        : (dados??[]).filter(
            (item, index, self) => index === self.findIndex((d) => d.cargo_nome === item.cargo_nome)
          )

    const filtradoPorPropriedade = filtro
      .filter((item) => item?.cod_propriedade === propriedade_selecionada_id)
      .filter(
        (item, index, self) => index === self.findIndex((d) => d.cargo_nome === item.cargo_nome)
      )
    return propriedade_selecionada_id > 0 ? filtradoPorPropriedade : filtro
  }

  function listagemPropriedade(item) {
    const dados = item?.filter((word) => word !== '')
    const filtro =
      propriedade_selecionada_id > 0
        ? dados
        : (dados??[]).filter(
            (item, index, self) =>
              index === self.findIndex((d) => d.propriedade_nome === item.propriedade_nome)
          )

    const filtradoPorPropriedade = filtro
      .filter((item) => item?.cod_propriedade === propriedade_selecionada_id)
      .filter(
        (item, index, self) =>
          index === self.findIndex((d) => d.propriedade_nome === item.propriedade_nome)
      )
    return propriedade_selecionada_id > 0 ? filtradoPorPropriedade : filtro
  }

  return (
    <>
      <Inline alignItems='center'>
        <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
          <Select
            value={propriedade_selecionada}
            placeholder='Selecione a propriedade'
            onChange={setPropriedade_selecionada}
            onChangeID={setIdPropriedade_selecionada}
            open={openSelect}
            trigger={setOpenSelect}
            items={propriedades}
            descricaoItem={'nome'}
            idItem={'cod'}
            width={500}
            icon={faMapLocationDot}
          />
          <Input
            placeholder='Buscar membro da equipe'
            value={buscarTabela}
            onChange={setBuscarTabela}
          />
          <ButtonCustom
            icon={<FontAwesomeIcon icon={faPlus} />}
            style={{ marginTop: '7px' }}
            onClick={() => setOpen(true)}
            disabled={
              permissao?.alteracao === 0 || permissao?.acesso === 1 || permissao?.inclusao === 0
            }
          >
            Atribuir
          </ButtonCustom>
        </div>
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 721px)' },
          { valor: 'Propriedades', width: '350px' },
          { valor: 'Cargos', width: '250px' },
          { valor: 'Ações', width: '115px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 300px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(listar_atribuicao ?? []).filter(buscarAtribuicao(buscarTabela)).map((item, index) => {
            return (
              <RowTable
                style={{ height: 'auto' }}
                key={item?.cod}
                onDoubleClick={() => editarCadastro(item?.cod)}
              >
                <RowItem width={'calc(100% - 715px)'}>{item?.usuario}</RowItem>
                <RowItem
                  fontSize={12}
                  width={'350px'}
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    alignContent: 'center',
                    marginTop: index === 0 ? '5px' : 0,
                  }}
                >
                  {listagemPropriedade(item?.cargos).map((item) => {
                    return (
                      <Tag color='blue' key={item} style={{ margin: 5 }}>
                        {item?.propriedade_nome}
                      </Tag>
                    )
                  })}
                </RowItem>

                <RowItem
                  fontSize={12}
                  width={'250px'}
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    alignContent: 'center',
                    marginTop: index === 0 ? '5px' : 0,
                  }}
                >
                  {listagemCargos(item?.cargos).map((item) => {
                    return (
                      <Tag color='green' key={item} style={{ margin: 5 }}>
                        {item?.cargo_nome}
                      </Tag>
                    )
                  })}
                </RowItem>

                <RowItem width={'115px'} gap={10} style={{ marginTop: index === 0 ? '7px' : 0 }}>
                  {/* <DeleteButton
                    open={confirmar_exclusao && id_item_atual === cod}
                    trigger={setConfirmar_exclusao}
                    onTrigger={() => {
                      setId_item_atual(cod)
                      setNome_item_atual(usuario)
                    }}
                    loading={fake_loading}
                    message={`o item ${usuario} será excluido!`}
                    deleteds={[usuario]}
                    onDelete={() => {
                      deletar(cod)
                    }}
                    disabled={fake_loading}
                    // disabledTrigger={permissao?.exclusao === 0}
                  /> */}
                  <ButtonCustom
                    icon={<FontAwesomeIcon icon={faEdit} />}
                    onClick={() => editarCadastro(item?.cod)}
                    disabled={
                      permissao?.alteracao === 0 ||
                      permissao?.acesso === 1 ||
                      permissao?.inclusao === 0
                    }
                  >
                    {permissao?.acesso === 1 ? 'Ver' : 'Editar'}
                  </ButtonCustom>
                </RowItem>
              </RowTable>
            )
          })}
        </Render>

        <Render condition={listar_atribuicao.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
              style={{ height: '500px' }}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando equipe...'
            justifyContent='center'
            height={450}
            size='default'
          />
        </Render>
      </BodyTable>
    </>
  )
}
